import { render, staticRenderFns } from "./NextJobsSetup.vue?vue&type=template&id=bc26000c&"
import script from "./NextJobsSetup.vue?vue&type=script&lang=js&"
export * from "./NextJobsSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports